import { RootState } from '../../store/rootReducer';

export const FaqContentSelector = (state: RootState) => state.content.faq;
